var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeteor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 213.6 51.5",
    style: {
      enableBackground: "new 0 0 213.6 51.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E44D26;}\r\n\t.st1{fill:#F16529;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#264DE4;}\r\n\t.st5{fill:#2965F1;}\r\n\t.st6{fill:#DAB92D;}\r\n\t.st7{fill:#FFD839;}\r\n\t.st8{fill:#53C1DE;}\r\n\t.st9{fill:#002A41;}\r\n\t.st10{fill:#0071B5;}\r\n\t.st11{fill:#DF4F4F;}\r\n\t.st12{fill:#26262C;}\r\n\t.st13{fill:#CCCCCC;}\r\n\t.st14{fill:#A6120D;}\r\n\t.st15{fill:#B3B3B3;}\r\n\t.st16{fill:#DD1B16;}\r\n\t.st17{fill:#F2F2F2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.542858, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-176.7,0l44.7,47.4c0,0,1.5,1.1,2.7-0.2s0.3-2.5,0.3-2.5L-176.7,0L-176.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-162.5,4.5l34,36.7c0,0,1.5,1.1,2.7-0.2s0.3-2.5,0.3-2.5L-162.5,4.5L-162.5,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-172.5,14.1l34.1,36.7c0,0,1.5,1.1,2.7-0.2s0.3-2.5,0.3-2.5L-172.5,14.1L-172.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-150.5,8.3l23.8,25.6c0,0,1.1,0.7,1.9-0.1s0.2-1.8,0.2-1.8L-150.5,8.3L-150.5,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-169.2,25.2l23.8,25.6c0,0,1.1,0.7,1.9-0.1s0.2-1.8,0.2-1.8L-169.2,25.2L-169.2,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-138.3,13.9l10.8,11.7c0,0,0.5,0.3,0.9-0.1s0.1-0.8,0.1-0.8L-138.3,13.9L-138.3,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-163.2,37l10.8,11.7c0,0,0.5,0.3,0.9-0.1c0.4-0.4,0.1-0.8,0.1-0.8L-163.2,37L-163.2,37z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 44.184078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186.3-25V6.5h7.1V-3.7h5.4l6.9,10.2h8.1l-7.6-10.9c0,0,6.7-2.6,6.7-9.9c0-10.2-9.3-10.6-9.3-10.6h-17.3 V-25z M193.4-18.9v9.1h9.1c0,0,3.5,0,3.5-4.6c0-4.8-4.2-4.6-4.2-4.6L193.4-18.9L193.4-18.9z M193.4-18.9v9.1h9.1 c0,0,3.5,0,3.5-4.6c0-4.8-4.2-4.6-4.2-4.6L193.4-18.9L193.4-18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.4-25V6.5h23.9V0.4h-16.8v-6.6H129v-6.1h-14.5v-6.6h16.8V-25H107.4L107.4-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.9-25v6.1h9.4V6.5h7.1v-25.4h9.4V-25H72.9L72.9-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.4-25V6.5h23.9V0.4H47.5v-6.6H62v-6.1H47.5v-6.6h16.8V-25H40.4L40.4-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0.2-25V6.5h7.1v-19.8L16-0.6l8.7-12.7V6.4h7.1v-31.5h-7.1l-8.7,13l-8.7-13L0.2-25L0.2-25z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M202,34.4h-8.5v-9.1h8.5c2.2,0,4.1,1.9,4.1,4.1v0.9C206.1,32.6,204.2,34.4,202,34.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteor);
export default __webpack_public_path__ + "static/media/meteor.0fae5f9f9becd831fddf29647d03411d.svg";
export { ForwardRef as ReactComponent };